const AR_TIPS = [
  "ابدأ بقراءة أهم النتائج أولًا، ثم انتقل إلى التحليل لفهم معنى الأرقام.",
  "قارن بين الفترات فقط إذا كانت العملة والفلاتر ونطاق التاريخ متطابقة.",
  "لا تعتمد على رقم واحد منفردًا؛ اربطه دائمًا ببقية المؤشرات الرئيسية.",
  "إذا ظهرت نسبة مرتفعة جدًا، فابحث عن البند الذي دفعها إلى هذا المستوى.",
  "النسبة المنخفضة ليست سلبية دائمًا؛ قد تعكس سياسة مالية محافظة.",
  "اقرأ التنبيهات بعناية لأنها غالبًا تشير إلى منطقة تحتاج مراجعة إضافية.",
  "التوصيات تساعدك على اتخاذ خطوة عملية، وليست مجرد ملخص لما حدث.",
  "تحقق من البنود ذات القيم السالبة لأنها قد تكون مؤثرة على التفسير النهائي.",
  "التغير الكبير في بند واحد قد يفسر معظم التغير في التقرير كله.",
  "ابدأ من الكروت الرئيسية ثم انزل إلى البنود التفصيلية إذا احتجت السبب.",
  "إذا كانت الأصول مرتفعة لكن السيولة ضعيفة، فراجع توزيع الأصول لا إجماليها فقط.",
  "عند قراءة الخصوم، فرّق بين القصيرة الأجل والطويلة الأجل لأن أثرهما مختلف.",
  "لا تفسر الربحية دون مراجعة الإيرادات والمصروفات معًا في نفس الفترة.",
  "البند الأعلى قيمة ليس دائمًا هو الأكثر خطورة؛ راقب أيضًا البنود غير المعتادة.",
  "عند وجود توصية بالمراجعة، ابدأ بالبند الذي تكرر ذكره في النتائج والتحليل.",
  "التحليل الجيد يربط بين الرقم والسبب والأثر، وليس الرقم وحده.",
  "إذا اختلفت النتائج عن توقعاتك، راجع الفلاتر قبل مراجعة البيانات نفسها.",
  "النسب مفيدة للمقارنة، أما القيم المطلقة فمفيدة لفهم الحجم الحقيقي.",
  "البنود المتداولة تعطيك فكرة أسرع عن القدرة على تغطية الالتزامات القريبة.",
  "التحليل يصبح أدق عندما تربط الأرقام بطبيعة نشاط المنشأة.",
  "عند ظهور هامش مرتفع، تحقق هل السبب تحسن الإيراد أم انخفاض المصروفات.",
  "البنود الصفرية أو القريبة من الصفر قد تعني غياب نشاط أو تصنيفًا غير مكتمل.",
  "إذا كانت التوصية عامة جدًا، ارجع إلى أهم النتائج لتعرف موضع التركيز الفعلي.",
  "ليس كل تنبيه مشكلة مؤكدة؛ أحيانًا يكون مجرد إشارة للمراجعة.",
  "تابع البنود التي تمثل نسبة كبيرة من الإجمالي لأنها الأكثر تأثيرًا على القرار.",
  "إذا ظهرت أرباح محتجزة مرتفعة، فاقرأها مع حقوق الملكية وليس بمعزل عنها.",
  "عند تقييم المديونية، راقب نسبة الدين مع حجم الأصول وحقوق الملكية معًا.",
  "التحليل المقارن بين الفترات أفضل من قراءة فترة واحدة بمعزل عن السياق.",
  "افصل بين أثر التشغيل وأثر التمويل عند قراءة الأداء المالي.",
  "إذا كانت الخلاصة إيجابية والتنبيهات كثيرة، راجع جودة البيانات قبل اتخاذ قرار.",
  "كلما زادت البنود الاستثنائية، زادت الحاجة إلى قراءة التوصيات بتركيز أكبر.",
  "القيمة الكبيرة في النقد لا تعني دائمًا وضعًا قويًا إذا كانت الالتزامات أعلى.",
  "التغيرات الصغيرة المتكررة قد تكون أهم من تغير واحد كبير حدث مرة واحدة.",
  "إذا كان التقرير عامًا، فاستخدمه كنقطة بداية ثم افتح التقرير المتخصص المناسب.",
  "لا تكتف بعنوان التقرير؛ اقرأ البنود التي بُني عليها التحليل.",
  "إذا كان بند واحد يشكل معظم الإجمالي، فقد يسيطر على قراءة التقرير بالكامل.",
  "راجع المسميات المحاسبية غير المألوفة لأنها قد تخفي بنودًا ذات أثر مهم.",
  "عند قراءة المخزون، راقب حجمه مع سرعة دورانه وليس قيمته وحدها.",
  "زيادة الذمم قد تعني نموًا، وقد تعني أيضًا بطئًا في التحصيل.",
  "عند قراءة السيولة، انتبه للبنود التي لا يمكن تحويلها إلى نقد بسرعة.",
  "كل توصية مرتبطة بسبب؛ ابحث عن السبب في فقرة التحليل قبل التنفيذ.",
  "التقرير لا يغني عن الحكم المهني، لكنه يوجهك إلى ما يستحق الاهتمام.",
  "إذا كان هامش الربح ثابتًا لكن صافي الدخل تغير، فابحث في المصاريف الأخرى.",
  "النسب المئوية تساعد على فهم التوزيع، لكنها لا تكشف الحجم الحقيقي وحدها.",
  "التحليل المتوازن ينظر إلى الأداء والهيكل المالي معًا.",
  "إذا ظهرت قيم سالبة في الأصول أو الالتزامات، فراجع التصنيف أو التسويات.",
  "اقرأ التوصيات بحسب الأولوية، لا بحسب ترتيب ظهورها فقط.",
  "تكرار نفس البند في النتائج والتنبيهات يعني أنه يحتاج اهتمامًا أسرع.",
  "إذا كانت معظم الأصول متداولة، فافحص جودة هذه الأصول وليس حجمها فقط.",
  "عند قراءة حقوق الملكية، انتبه إن كانت مدعومة بأرباح محتجزة أم برأس مال فقط.",
  "لا تُقارن تقارير بطرق تحليل مختلفة وكأنها تعطي نفس الدلالة تمامًا.",
  "عندما ترى تغيرًا مفاجئًا، راجع هل هو موسمي أم استثنائي أم مستمر.",
  "كل رقم مهم يجب أن يُقرأ داخل سياق الفترة والنشاط والفلاتر المستخدمة.",
  "استخدم التقرير كأداة للحوار مع الإدارة، لا كبديل عن فهم النشاط نفسه.",
];

const EN_TIPS = [
  "Start with the key findings first, then review the analysis to understand what the numbers mean.",
  "Compare periods only when currency, filters, and date range are identical.",
  "Do not rely on a single number alone; always connect it to the other key metrics.",
  "If a ratio is unusually high, look for the line item pushing it upward.",
  "A low ratio is not always negative; it may reflect a conservative financial policy.",
  "Read alerts carefully because they often point to an area that needs extra review.",
  "Recommendations are meant to guide action, not just repeat what happened.",
  "Check negative line items because they may materially affect the final interpretation.",
  "A large movement in one item can explain most of the report's overall change.",
  "Start with the summary cards, then move to detailed items if you need the cause.",
  "If assets are high but liquidity is weak, review the asset mix, not only the total.",
  "When reading liabilities, separate short-term from long-term because their impact differs.",
  "Do not interpret profitability without reviewing revenue and expenses together.",
  "The largest line item is not always the riskiest; unusual items also matter.",
  "When a recommendation asks for review, start with the line item repeated in the findings.",
  "Good analysis links the number, the reason, and the impact, not the number alone.",
  "If the results differ from expectations, check the filters before questioning the data.",
  "Ratios help comparison, while absolute values help explain true scale.",
  "Current items give a faster signal about the ability to cover near-term obligations.",
  "Analysis becomes more accurate when you connect the figures to the company's activity.",
  "When a margin improves, check whether revenue rose or expenses fell.",
  "Zero or near-zero items may indicate no activity or incomplete classification.",
  "If a recommendation feels general, return to the key findings to locate the real focus.",
  "Not every alert is a confirmed issue; sometimes it is simply a review signal.",
  "Watch items that represent a large share of the total because they drive decisions.",
  "If retained earnings are high, read them together with total equity.",
  "When assessing leverage, read debt against both assets and equity.",
  "Period-over-period analysis is stronger than reading one period in isolation.",
  "Separate operating effects from financing effects when reading performance.",
  "If the summary is positive but alerts are numerous, review data quality before deciding.",
  "The more exceptional items appear, the more carefully recommendations should be read.",
  "A large cash balance does not always mean strength if liabilities are even larger.",
  "Repeated small changes can matter more than a single large one that happened once.",
  "If the report is general, use it as a starting point before opening a specialized report.",
  "Do not stop at the report title; read the basis used to build the analysis.",
  "If one line item dominates the total, it may shape the entire report reading.",
  "Review unfamiliar accounting labels because they may hide material items.",
  "When reading inventory, consider both its size and its turnover speed.",
  "Higher receivables may reflect growth, but they can also signal slower collections.",
  "When reading liquidity, pay attention to items that cannot be converted to cash quickly.",
  "Every recommendation has a reason; find that reason in the analysis before acting.",
  "The report does not replace professional judgment, but it points to what deserves attention.",
  "If gross margin is stable but net income changed, review other expense lines.",
  "Percentages explain distribution, but not full size on their own.",
  "Balanced reading looks at both performance and financial structure.",
  "If negative values appear in assets or liabilities, review classification or adjustments.",
  "Read recommendations by priority, not only by the order they appear.",
  "If the same item appears in findings and alerts, it likely needs faster attention.",
  "If most assets are current, assess their quality and not only their amount.",
  "When reading equity, check whether it is supported by retained earnings or only capital.",
  "Do not compare reports built with different analysis methods as if they mean the same thing.",
  "When you see a sudden change, ask whether it is seasonal, exceptional, or ongoing.",
  "Every important figure should be read within the period, activity, and filter context.",
  "Use the report as a discussion tool with management, not as a substitute for understanding the business.",
];

export const getAnalysisTips = (_t, language) => (language === "en" ? EN_TIPS : AR_TIPS);

export const getRandomTipIndex = (tipsCount, currentIndex = -1) => {
  if (tipsCount <= 1) {
    return 0;
  }

  let nextIndex = currentIndex;

  while (nextIndex === currentIndex) {
    nextIndex = Math.floor(Math.random() * tipsCount);
  }

  return nextIndex;
};
